<template>
  <div class="legal">
    <header class="legal__nav">
      <router-link to="/" class="legal__brand">{{ LEGAL_OPERATOR.brandName }}</router-link>
      <router-link to="/" class="legal__back">На главную</router-link>
    </header>

    <article class="legal__body">
      <h1>{{ title }}</h1>
      <p v-if="editedAt" class="legal__meta">Редакция от {{ editedAt }}</p>
      <slot />

      <section v-if="showRequisites">
        <h2>Реквизиты и контакты</h2>
        <p>{{ LEGAL_OPERATOR.fullName }}</p>
        <p>ИНН: {{ LEGAL_OPERATOR.inn }}</p>
        <p>ОГРНИП: {{ LEGAL_OPERATOR.ogrnip }} от {{ LEGAL_OPERATOR.ogrnipIssuedAt }}</p>
        <p>Местоположение: {{ LEGAL_OPERATOR.location }}</p>
        <p>Дата регистрации: {{ LEGAL_OPERATOR.registeredAt }}</p>
        <p>
          <a :href="LEGAL_OPERATOR.emailHref">{{ LEGAL_OPERATOR.email }}</a>,
          <a :href="LEGAL_OPERATOR.phoneHref">{{ LEGAL_OPERATOR.phone }}</a>
        </p>
      </section>
    </article>

    <footer class="legal__foot">
      © {{ year }} {{ LEGAL_OPERATOR.brandName }} · <router-link to="/">Главная</router-link>
    </footer>
  </div>
</template>

<script setup>
import { LEGAL_OPERATOR } from '@/content/legal/operator'

defineProps({
  title: { type: String, required: true },
  editedAt: { type: String, default: '' },
  showRequisites: { type: Boolean, default: true },
})

const year = new Date().getFullYear()
</script>

<style scoped>
.legal { min-height: 100vh; background: #fbfbfd; color: #1d1d1f; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif; }
.legal__nav { display: flex; justify-content: space-between; padding: 1rem 1.5rem; border-bottom: 1px solid #e5e5e7; position: sticky; top: 0; background: rgba(251,251,253,.9); backdrop-filter: blur(12px); }
.legal__brand { font-weight: 600; color: #1d1d1f; text-decoration: none; }
.legal__back { color: #0071e3; text-decoration: none; font-size: .9rem; }
.legal__body { max-width: 720px; margin: 0 auto; padding: 2.5rem 1.5rem; }
.legal__body h1 { font-size: 2rem; font-weight: 700; letter-spacing: -.02em; }
.legal__meta { color: #6e6e73; margin-bottom: 2rem; }
.legal__body h2 { font-size: 1.1rem; margin: 1.75rem 0 .5rem; }
.legal__body p, .legal__body li { line-height: 1.65; color: #424245; font-size: .95rem; }
.legal__foot { max-width: 720px; margin: 0 auto; padding: 1rem 1.5rem 2rem; font-size: .85rem; color: #6e6e73; border-top: 1px solid #e5e5e7; }
.legal__foot a, .legal__body a { color: #0071e3; text-decoration: none; }
</style>
